import { joinTimeIntervals } from './joinTimeIntervals.main';

export { joinTimeIntervals };
